import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckCircleIcon } from 'lucide-react';
interface WhatsAppJoinModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const WhatsAppJoinModal: React.FC<WhatsAppJoinModalProps> = ({
  isOpen,
  onClose
}) => {
  const whatsappGroupLink = 'https://chat.whatsapp.com/GygQqngd28sGpI0BPFEeZD';
  const handleJoinWhatsApp = () => {
    window.open(whatsappGroupLink, '_blank');
  };
  return <AnimatePresence data-id="element-207">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50" onClick={onClose} data-id="element-208" />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-209">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="w-full max-w-md max-h-[90vh] overflow-y-auto" data-id="element-210">
              <div className="bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-purple-500/50 rounded-2xl p-6 sm:p-8 shadow-2xl shadow-purple-500/20 relative" data-id="element-211">
                <button onClick={onClose} className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-white transition-colors z-10" data-id="element-212">
                  <XIcon size={20} className="sm:w-6 sm:h-6" data-id="element-213" />
                </button>
                <div className="text-center mb-4 sm:mb-6" data-id="element-214">
                  <div className="inline-flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 bg-yellow-500/20 rounded-full mb-3 sm:mb-4" data-id="element-215">
                    <span className="text-3xl sm:text-4xl" data-id="element-216">⚠️</span>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold mb-2 px-6" data-id="element-217">
                    ¡Tu registro NO está completo!
                  </h3>
                </div>
                <div className="mb-4 sm:mb-6" data-id="element-218">
                  <div className="flex justify-between items-center mb-2" data-id="element-219">
                    <span className="text-xs sm:text-sm text-gray-400" data-id="element-220">
                      Progreso del registro
                    </span>
                    <span className="text-xs sm:text-sm font-bold text-purple-400" data-id="element-221">
                      95%
                    </span>
                  </div>
                  <div className="w-full h-2 sm:h-3 bg-gray-800 rounded-full overflow-hidden" data-id="element-222">
                    <motion.div initial={{
                  width: 0
                }} animate={{
                  width: '95%'
                }} transition={{
                  duration: 1,
                  ease: 'easeOut'
                }} className="h-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 relative" data-id="element-223">
                      <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-224"></div>
                    </motion.div>
                  </div>
                </div>
                <div className="bg-purple-900/30 border border-purple-500/30 rounded-lg p-3 sm:p-4 mb-4 sm:mb-6" data-id="element-225">
                  <div className="flex items-start gap-2 sm:gap-3 mb-3 sm:mb-4" data-id="element-226">
                    <CheckCircleIcon className="text-green-400 flex-shrink-0 mt-1" size={18} data-id="element-227" />
                    <div data-id="element-228">
                      <p className="text-xs sm:text-sm text-gray-300" data-id="element-229">
                        Tu registro solo se completará cuando te unas a nuestro
                        grupo exclusivo de WhatsApp.
                      </p>
                    </div>
                  </div>
                  <p className="text-xs sm:text-sm text-gray-400 mb-2" data-id="element-230">
                    En el grupo recibirás:
                  </p>
                  <ul className="text-xs sm:text-sm text-gray-300 space-y-1" data-id="element-231">
                    <li data-id="element-232">• Recordatorio del evento</li>
                    <li data-id="element-233">• Link de acceso a la clase</li>
                    <li data-id="element-234">• Recursos exclusivos</li>
                    <li data-id="element-235">• Soporte directo</li>
                  </ul>
                </div>
                <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={handleJoinWhatsApp} className="w-full py-3 sm:py-4 px-4 sm:px-6 bg-gradient-to-r from-green-600 to-green-500 rounded-lg font-bold text-white text-base sm:text-lg shadow-lg shadow-green-500/20 flex items-center justify-center gap-2" data-id="element-236">
                  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" data-id="element-237">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-238" />
                  </svg>
                  <span className="text-sm sm:text-base" data-id="element-239">
                    Unirme al grupo de WhatsApp ahora
                  </span>
                </motion.button>
                <p className="text-xs text-gray-500 text-center mt-3 sm:mt-4" data-id="element-240">
                  No te pierdas ningún detalle importante. ¡Únete ahora!
                </p>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
};